module.exports = __webpack_public_path__ + "img/planet-mars-internal.9f7781a3.svg";